import {ref, Ref} from "vue"

const isAcceptConditions: Ref<boolean> = ref(false)

export default isAcceptConditions